import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/router';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { generatePretendUserUrl } from 'shared/hooks/use-user/utils/generate-pretend-user-url';
import { UserInterface } from 'shared/types/user-interface';
import { hasSubAccounts } from '../utils/has-subaccounts';
interface UseUserSubaccountsProps {
  dashboardUser?: UserInterface;
  isSupportImpersonation: boolean;
}
export const useUserSubaccounts = t0 => {
  const $ = _c(10);
  const {
    dashboardUser,
    isSupportImpersonation
  } = t0;
  const {
    push
  } = useRouter();
  useLocoTranslation();
  let t1;
  if ($[0] !== dashboardUser) {
    t1 = () => {
      if (!dashboardUser || !hasSubAccounts(dashboardUser) || !dashboardUser.mainUser) {
        return;
      }
      const getCustomCaption = _temp;
      return [{
        id: dashboardUser.mainUser.user.id,
        caption: dashboardUser.mainUser.displayName,
        customCaption: getCustomCaption(dashboardUser?.subaccountsAvatarUrls[dashboardUser.mainUser.user.id] ?? undefined, dashboardUser.mainUser.displayName)
      }, ...dashboardUser.subaccounts.map(t2 => {
        const {
          user: t3,
          displayName
        } = t2;
        const {
          id
        } = t3;
        return {
          id,
          caption: displayName,
          customCaption: getCustomCaption(dashboardUser?.subaccountsAvatarUrls[id] ?? undefined, displayName)
        };
      })];
    };
    $[0] = dashboardUser;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const subAccountsData = t1;
  let t2;
  if ($[2] !== dashboardUser?.id || $[3] !== dashboardUser?.mainUser || $[4] !== isSupportImpersonation || $[5] !== push) {
    t2 = id_0 => {
      if (!id_0 || id_0 === dashboardUser?.id || !dashboardUser?.mainUser) {
        return;
      }
      const isImpersonateToMainAccount = id_0 === dashboardUser?.mainUser.user.id;
      let query = encodeURIComponent(id_0);
      if (isImpersonateToMainAccount && !isSupportImpersonation) {
        query = "_exit";
      }
      push(generatePretendUserUrl(query));
    };
    $[2] = dashboardUser?.id;
    $[3] = dashboardUser?.mainUser;
    $[4] = isSupportImpersonation;
    $[5] = push;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const changeSubAccount = t2;
  let t3;
  if ($[7] !== changeSubAccount || $[8] !== subAccountsData) {
    t3 = {
      subAccountsData,
      changeSubAccount
    };
    $[7] = changeSubAccount;
    $[8] = subAccountsData;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
function _temp(image, name) {
  return <div className="text-start flex items-center gap-3">{image && <img className="h-7 w-7 overflow-hidden rounded-full object-cover" src={image} alt={name} />}<div className="flex flex-col">{name}</div></div>;
}